import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "o-text-caption flex gap-x1 mt-x4" }

import NetPrice from '@/b2b/shared/auth/ui/NetPrice.vue';
import { computed } from 'vue';
import authStore from '@/shared/auth/auth.store';
import useProductDetailData from '@/shared/product/details/useProductDetailData';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetailItemId',
  setup(__props) {

const { variantId, productId } = useProductDetailData();

const labels = useBlockLabels();

const isSignedInAsPartner = computed<boolean>(() => {
    return authStore.isSignedInAsPartner;
});

return (_ctx: any,_cache: any) => {
  return (_unref(isSignedInAsPartner))
    ? (_openBlock(), _createBlock(NetPrice, { key: 0 }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).b2BProductIdAndVariantId, { productId: _unref(productId), variantId: _unref(variantId) })), 1)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})